// extracted by mini-css-extract-plugin
export default {"card1":"kl7Km2ZN","_type1":"V_vgasiZ","mobile":"mobile","image":"k4X4XcFp","link":"lg7o4iRy","icon":"NZgM35kc","rubric":"ZIHmbKjb","time":"UThOHdKk","desktop":"desktop"};